<template>
	<div class="loginSpinner">
		<div class="d-flex justify-content-center mb-3">
			<b-spinner label="Loading..."  style="width: 5rem; height: 5rem;" variant="success"></b-spinner>
		</div>
	</div>
</template>
<script>
import {RepositoryFactory} from '../api/RepositoryFactory'
const SettingsRepoGet = RepositoryFactory.get('settings')
export default{
	name: 'Login',
	components: {},
	props: ['storeId', 'accessToken'],
	data(){
		return{}
	},
	created(){
		//window.localStorage.clear()
			//		this.$nextTick().then(() => {
			//	console.log(window.localStorage)	
		//this.getStoreSettings(this.$store.state.storeId)			
		//	});	
		this.redirect()
	},
	methods: {
		async getStoreSettings(storeId)
		{
			const {data}  =	await SettingsRepoGet.getAllStoreSettings(storeId)	
			console.log(data)	
			console.log(this.$store.state)	
			console.log(this.$store.state.loggedIn)
			this.$store.commit("getStoreSettings", data);
		},
		redirect()
		{
			setTimeout(() => {
			//loader.hide()	
			window.location = ('/')
			}, 3000)
		}
	}	
}

</script>
<style scoped>

.loginSpinner {
  margin-top: 20%  
}
</style>